export default "__VITE_ASSET__BiclrpDJ__"